import React from 'react';
import forLayout from '../../use/useForLayout';
import Footer from '../Footer';

export default React.memo(() => {
  const show = forLayout.useFooterJudgement();

  if (!show) return null;

  return <Footer />;
});
